import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { BRAND_ALIGNMENT_ITEMS } from 'site-modules/shared/constants/brand-alignment';

import './brand-module-cards.scss';

export function BrandModuleCards({
  className = null,
  headingClassName = null,
  subHeadingClassName = null,
  dataTrackingParent = 'edm-entry-brand-module',
  isMobile = false,
}) {
  return (
    <div className={classnames('brand-module-cards', className)} data-tracking-parent={dataTrackingParent}>
      <h2 className={classnames('mb-0_75', headingClassName)}>We drive it like it is</h2>
      <div className={classnames('size-20 text-gray-darker', subHeadingClassName)}>
        With over 50 years of experience, we’re the trusted guide in car shopping.
      </div>
      <Row tag="ul" className="brand-list list-unstyled mb-0">
        {BRAND_ALIGNMENT_ITEMS().map(({ label, description, icon }) => (
          <Col tag="li" xs={12} md={3} key={label} className="brand-item mt-0_75 mt-md-0">
            <div
              className={classnames('bg-white d-flex align-items-center align-items-md-start h-100 px-0_5 p-md-1_25', {
                card: !isMobile,
              })}
            >
              <i
                className={classnames(
                  'item-icon d-flex align-items-center justify-content-center text-primary me-1 me-md-0 mb-md-0_25',
                  icon,
                  {
                    'size-20': !isMobile,
                    'size-16': isMobile,
                  }
                )}
              />
              <div className="text-gray-darker">
                <div className="heading-5 mb-md-0_25">{label}</div>
                {description}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

BrandModuleCards.propTypes = {
  className: PropTypes.string,
  headingClassName: PropTypes.string,
  subHeadingClassName: PropTypes.string,
  dataTrackingParent: PropTypes.string,
  isMobile: PropTypes.bool,
};
